import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import useValueForCurrentViewPort from '../../../helpers/useValueForCurrentViewPort';
import i18next from '../../../config/i18next';

import {
  SliderRelated,
} from '../../../components';

import './style.scss';


const SiaProjectsRelated = ({ entities }) => {
  const slidesToShow = useValueForCurrentViewPort(1, 1, 3, 3, 3);

  return (entities && entities.size > 0) && (
    <div className="View SiaProjectsRelated">
      <SliderRelated title={i18next.t('sia_others_also_viewed')} slidesToShow={slidesToShow}>
        {entities.map((entity) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const className = 'SiaProjectsRelated__item';
          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                key={`${uuid}:${langcode}`}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </SliderRelated>
    </div>
  );
};

export default SiaProjectsRelated;
